import { useLocation } from "react-router-dom";
import React, { useEffect } from "react";
import GeneralAuthentication from "../general/GeneralAuthentication";
import AuthBrokerProspect from "../general/AuthBrokerProspect";
import { useDispatch } from "react-redux";
import { storeProspectid, showingSendToInsurers } from "../store/quotes";
import MainPane from "../general/MainPane";
import CheckForInvalidLink from "../general/CheckForInvalidLink";
import TwoPanesPanel from "../general/TwoPanesPanel";

const SendToInsurers = () => {
  const { search } = useLocation();
  const dispatch = useDispatch();

  const prospectid = search.substring(4);

  let valid = false;
  if (prospectid && prospectid.length >= 24) valid = true;

  useEffect(() => {
    dispatch(storeProspectid(prospectid));
    dispatch(showingSendToInsurers(false));
  }, [dispatch, prospectid]);

  return (
    <GeneralAuthentication>
      <CheckForInvalidLink valid={valid}>
        <AuthBrokerProspect prospectid={prospectid}>
          <MainPane>
            <TwoPanesPanel></TwoPanesPanel>
          </MainPane>
        </AuthBrokerProspect>
      </CheckForInvalidLink>
    </GeneralAuthentication>
  );
};

export default SendToInsurers;
